import React, {memo} from 'react'
import {Flex, Text} from '../../vanilla'
import {ReviewStars} from '../review-stars'

interface StarRatingProps {
  rating?: number
  reviewCount?: number
  showReviewCount?: boolean
  onReviewClick?: () => void
}

export const StarRating = memo(
  ({rating = 0, reviewCount = 0, showReviewCount = true, onReviewClick }: StarRatingProps) => {
    return (
      <Flex align="center" gap="4px" data-test-selector="product-star-rating">
        <ReviewStars rating={rating} />
        {showReviewCount && (
          <Text variant="text3" color="textMuted" onClick={onReviewClick} style={{ cursor: 'pointer' }} data-test-selector="product-review-count">
            ({reviewCount} product reviews)
          </Text>
        )}
      </Flex>
    )
  },
)
